var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roll-box"},[_c('div',{class:'roll-list-' + _vm.index},_vm._l((_vm.numbers),function(num){return _c('div',{key:num,staticClass:"roll-number"},[_vm._v(" "+_vm._s(num)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }